module.exports = __webpack_public_path__ + "static/sunset-ac91f64f718a8b5cc47ddc2f6a07bfd3.gif";